// tanstack
import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/$accountId/_admin/service-manager/$managedAccountId/',
)({
  component: () => (
    <Navigate to="/$accountId/service-manager/$managedAccountId/alarms" />
  ),
});
